export const dataKeysExceptions = error => {
  const data = [];

  switch (error.parameter) {
    case 'cnes':
      data.push({ exception: error.exception, parameter: 'cnes' });
      break;

    case 'periodo':
      data.push({ exception: error.exception, parameter: 'periodo' });
      break;

    case 'partos_vaginais':
      data.push({ exception: error.exception, parameter: 'partos_vaginais' });
      break;

    case 'partos':
      data.push({ exception: error.exception, parameter: 'partos' });
      break;

    case 'int_cli':
      data.push({ exception: error.exception, parameter: 'int_cli' });
      break;

    case 'saidas_cli':
      data.push({ exception: error.exception, parameter: 'saidas_cli' });
      break;

    case 'int_cir':
      data.push({ exception: error.exception, parameter: 'int_cir' });
      break;

    case 'saidas_cir':
      data.push({ exception: error.exception, parameter: 'saidas_cir' });
      break;

    case 'pcr_ui':
      data.push({ exception: error.exception, parameter: 'pcr_ui' });
      break;

    case 'pd_ui':
      data.push({ exception: error.exception, parameter: 'pd_ui' });
      break;

    case 'obitos_np_cli':
      data.push({ exception: error.exception, parameter: 'obitos_np_cli' });
      break;

    case 'saidas_np_cli':
      data.push({ exception: error.exception, parameter: 'saidas_np_cli' });
      break;

    case 'obitos_nt_cli':
      data.push({ exception: error.exception, parameter: 'obitos_nt_cli' });
      break;

    case 'saidas_nt_cli':
      data.push({ exception: error.exception, parameter: 'saidas_nt_cli' });
      break;

    case 'obitos_ped_cli':
      data.push({ exception: error.exception, parameter: 'obitos_ped_cli' });
      break;

    case 'saidas_ped_cli':
      data.push({ exception: error.exception, parameter: 'saidas_ped_cli' });
      break;

    case 'obitos_adu_cli':
      data.push({ exception: error.exception, parameter: 'obitos_adu_cli' });
      break;

    case 'saidas_adu_cli':
      data.push({ exception: error.exception, parameter: 'saidas_adu_cli' });
      break;

    case 'obitos_ido_cli':
      data.push({ exception: error.exception, parameter: 'obitos_ido_cli' });
      break;

    case 'saidas_ido_cli':
      data.push({ exception: error.exception, parameter: 'saidas_ido_cli' });
      break;

    case 'obitos_neop_cir':
      data.push({ exception: error.exception, parameter: 'obitos_neop_cir' });
      break;

    case 'saidas_neop_cir':
      data.push({ exception: error.exception, parameter: 'saidas_neop_cir' });
      break;

    case 'obitos_neot_cir':
      data.push({ exception: error.exception, parameter: 'obitos_neot_cir' });
      break;

    case 'saidas_neot_cir':
      data.push({ exception: error.exception, parameter: 'saidas_neot_cir' });
      break;

    case 'obitos_ped_cir':
      data.push({ exception: error.exception, parameter: 'obitos_ped_cir' });
      break;

    case 'saidas_ped_cir':
      data.push({ exception: error.exception, parameter: 'saidas_ped_cir' });
      break;

    case 'obitos_adu_cir':
      data.push({ exception: error.exception, parameter: 'obitos_adu_cir' });
      break;

    case 'saidas_adu_cir':
      data.push({ exception: error.exception, parameter: 'saidas_adu_cir' });
      break;

    case 'obitos_ido_cir':
      data.push({ exception: error.exception, parameter: 'obitos_ido_cir' });
      break;

    case 'saidas_ido_cir':
      data.push({ exception: error.exception, parameter: 'saidas_ido_cir' });
      break;

    case 'pd_ped_cli':
      data.push({ exception: error.exception, parameter: 'pd_ped_cli' });
      break;

    case 'saidas_ped_cli_ti':
      data.push({ exception: error.exception, parameter: 'saidas_ped_cli_ti' });
      break;

    case 'pd_adu_cli':
      data.push({ exception: error.exception, parameter: 'pd_adu_cli' });
      break;

    case 'saidas_adu_cli_ti':
      data.push({ exception: error.exception, parameter: 'saidas_adu_cli_ti' });
      break;

    case 'pd_ido_cli':
      data.push({ exception: error.exception, parameter: 'pd_ido_cli' });
      break;

    case 'saidas_ido_cli_ti':
      data.push({ exception: error.exception, parameter: 'saidas_ido_cli_ti' });
      break;

    case 'pd_ped_cir':
      data.push({ exception: error.exception, parameter: 'pd_ped_cir' });
      break;

    case 'saidas_ped_cir_ti':
      data.push({ exception: error.exception, parameter: 'saidas_ped_cir_ti' });
      break;

    case 'pq_adu_cir':
      data.push({ exception: error.exception, parameter: 'pq_adu_cir' });
      break;

    case 'saidas_adu_cir_ti':
      data.push({ exception: error.exception, parameter: 'saidas_adu_cir_ti' });
      break;

    case 'pd_ido_cir':
      data.push({ exception: error.exception, parameter: 'pd_ido_cir' });
      break;

    case 'saidas_ido_cir_ti':
      data.push({ exception: error.exception, parameter: 'saidas_ido_cir_ti' });
      break;

    case 'tempo_emergencia':
      data.push({ exception: error.exception, parameter: 'tempo_emergencia' });
      break;

    case 'pac_emergencia':
      data.push({ exception: error.exception, parameter: 'pac_emergencia' });
      break;

    case 'esp_1aten_n2':
      data.push({ exception: error.exception, parameter: 'esp_1aten_n2' });
      break;

    case 'pacientes_n2':
      data.push({ exception: error.exception, parameter: 'pacientes_n2' });
      break;

    case 'esp_1aten_n3':
      data.push({ exception: error.exception, parameter: 'esp_1aten_n3' });
      break;

    case 'pacientes_n3':
      data.push({ exception: error.exception, parameter: 'pacientes_n3' });
      break;

    case 'cir_lim_prof60m':
      data.push({ exception: error.exception, parameter: 'cir_lim_prof60m' });
      break;

    case 'cir_lim':
      data.push({ exception: error.exception, parameter: 'cir_lim' });
      break;

    case 'isc_cir_lim':
      data.push({ exception: error.exception, parameter: 'isc_cir_lim' });
      break;
    
      case 'total_cir_lim':
      data.push({ exception: error.exception, parameter: 'total_cir_lim' });
      break;

    case 'ics_cvc_ui_neo':
      data.push({ exception: error.exception, parameter: 'ics_cvc_ui_neo' });
      break;

    case 'pac_ui_neo_cvcdia':
      data.push({ exception: error.exception, parameter: 'pac_ui_neo_cvcdia' });
      break;

    case 'ics_cvc_ui_ped':
      data.push({ exception: error.exception, parameter: 'ics_cvc_ui_ped' });
      break;

    case 'pac_ui_ped_cvcdia':
      data.push({ exception: error.exception, parameter: 'pac_ui_ped_cvcdia' });
      break;

    case 'ics_cvc_ui_adu':
      data.push({ exception: error.exception, parameter: 'ics_cvc_ui_adu' });
      break;

    case 'pac_ui_adu_cvcdia':
      data.push({ exception: error.exception, parameter: 'pac_ui_adu_cvcdia' });
      break;

    case 'ics_cvc_uti_neo':
      data.push({ exception: error.exception, parameter: 'ics_cvc_uti_neo' });
      break;

    case 'pac_uti_neo_cvcdia':
      data.push({
        exception: error.exception,
        parameter: 'pac_uti_neo_cvcdia',
      });
      break;

    case 'ics_cvc_uti_ped':
      data.push({ exception: error.exception, parameter: 'ics_cvc_uti_ped' });
      break;

    case 'pac_uti_ped_cvcdia':
      data.push({
        exception: error.exception,
        parameter: 'pac_uti_ped_cvcdia',
      });
      break;

    case 'ics_cvc_uti_adu':
      data.push({ exception: error.exception, parameter: 'ics_cvc_uti_adu' });
      break;

    case 'pac_uti_adu_cvcdia':
      data.push({
        exception: error.exception,
        parameter: 'pac_uti_adu_cvcdia',
      });
      break;

    case 'itu_cvd_ui_neo':
      data.push({ exception: error.exception, parameter: 'itu_cvd_ui_neo' });
      break;

    case 'pac_ui_neo_cvddia':
      data.push({ exception: error.exception, parameter: 'pac_ui_neo_cvddia' });
      break;

    case 'itu_cvd_ui_ped':
      data.push({ exception: error.exception, parameter: 'itu_cvd_ui_ped' });
      break;

    case 'pac_ui_ped_cvddia':
      data.push({ exception: error.exception, parameter: 'pac_ui_ped_cvddia' });
      break;

    case 'itu_cvc_ui_adu':
      data.push({ exception: error.exception, parameter: 'itu_cvc_ui_adu' });
      break;

    case 'pac_ui_adu_cvddia':
      data.push({ exception: error.exception, parameter: 'pac_ui_adu_cvddia' });
      break;

    case 'itu_cvd_uti_neo':
      data.push({ exception: error.exception, parameter: 'itu_cvd_uti_neo' });
      break;

    case 'pac_uti_neo_cvddia':
      data.push({
        exception: error.exception,
        parameter: 'pac_uti_neo_cvddia',
      });
      break;

    case 'itu_cvc_uti_ped':
      data.push({ exception: error.exception, parameter: 'itu_cvc_uti_ped' });
      break;

    case 'pac_uti_ped_cvddia':
      data.push({
        exception: error.exception,
        parameter: 'pac_uti_ped_cvddia',
      });
      break;

    case 'itu_cvc_uti_adu':
      data.push({ exception: error.exception, parameter: 'itu_cvc_uti_adu' });
      break;

    case 'pac_uti_adu_cvddia':
      data.push({
        exception: error.exception,
        parameter: 'pac_uti_adu_cvddia',
      });
      break;

    case 'prof_tev_ris_tro_cli':
      data.push({
        exception: error.exception,
        parameter: 'prof_tev_ris_tro_cli',
      });
      break;
    case 'ris_tro_cli':
      data.push({ exception: error.exception, parameter: 'ris_tro_cli' });
      break;

    case 'prof_tev_ris_tro_cir_ort':
      data.push({
        exception: error.exception,
        parameter: 'prof_tev_ris_tro_cir_ort',
      });
      break;

    case 'ris_tro_cir_ort':
      data.push({ exception: error.exception, parameter: 'ris_tro_cir_ort' });
      break;

    case 'prof_tev_ris_tro_cir_nao_ort':
      data.push({
        exception: error.exception,
        parameter: 'prof_tev_ris_tro_cir_nao_ort',
      });
      break;

    case 'ris_tro_cir_nao_ort':
      data.push({
        exception: error.exception,
        parameter: 'ris_tro_cir_nao_ort',
      });
      break;

    case 'quedas':
      data.push({ exception: error.exception, parameter: 'quedas' });
      break;

    case 'pd':
      data.push({ exception: error.exception, parameter: 'pd' });
      break;

    case 'eve_sentinela':
      data.push({ exception: error.exception, parameter: 'eve_sentinela' });
      break;

    // case 'total_internacoes':
    //   data.push({ exception: error.exception, parameter: 'total_internacoes' });
    //   break;

    default:
      data.push({ exception: error.exception, parameter: error.parameter });
      break;
  }

  return data;
};
